export default function tickerFeedDataSelector(func) {
  return func((state) => state.tickerFeedReducer);
}
